import React from 'react';

import { MdmObject, useGetObjectQuery } from 'gql/generated/types';
import { useParams } from 'react-router-dom';
import MapWrapper from '../components/MapWrapper';
import ObjectMapContent from '../components/ObjectMapContent';

const SingleObjectMap = () => {
  const { objectId } = useParams();
  const { data } = useGetObjectQuery({ variables: { id: objectId! }, skip: !objectId });
  return (
      <MapWrapper>
        <ObjectMapContent objects={([data?.mdmObjectById] ?? []) as MdmObject[]} />
      </MapWrapper>
  );
}

export default SingleObjectMap
